import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RenameChatContextType {
  isRenameDialogOpen: boolean;
  renameChatId: string | null;
  renameChatTitle: string;
  openRenameDialog: (chatId: string, currentTitle: string) => void;
  closeRenameDialog: () => void;
}

const RenameChatContext = createContext<RenameChatContextType | undefined>(undefined);

interface RenameChatProviderProps {
  children: ReactNode;
}

export const RenameChatProvider: React.FC<RenameChatProviderProps> = ({ children }) => {
  const [isRenameDialogOpen, setIsRenameDialogOpen] = useState(false);
  const [renameChatId, setRenameChatId] = useState<string | null>(null);
  const [renameChatTitle, setRenameChatTitle] = useState('');

  const openRenameDialog = (chatId: string, currentTitle: string) => {
    setRenameChatId(chatId);
    setRenameChatTitle(currentTitle);
    setIsRenameDialogOpen(true);
  };

  const closeRenameDialog = () => {
    setIsRenameDialogOpen(false);
    setRenameChatId(null);
    setRenameChatTitle('');
  };

  return (
    <RenameChatContext.Provider value={{
      isRenameDialogOpen,
      renameChatId,
      renameChatTitle,
      openRenameDialog,
      closeRenameDialog
    }}>
      {children}
    </RenameChatContext.Provider>
  );
};

export const useRenameChat = (): RenameChatContextType => {
  const context = useContext(RenameChatContext);
  if (context === undefined) {
    throw new Error('useRenameChat must be used within a RenameChatProvider');
  }
  return context;
};







